import React from 'react';

import { useLocation } from 'react-router-dom';
import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';

import { NavigationHeader } from 'components/Settings/Components/Opc/NavigationHeader/NavigationHeader';
import { settingsConfig } from 'components/Settings/settingsConfig';
import { OpcCredentials } from 'components/pages/OpcCredentialsPage/components/OpcCredentials/OpcCredentials';

export const OpcCredentialsPage = () => {
    const { pathname } = useLocation();
    const isEditMode = pathname.includes(`/${settingsConfig.opc.link}/${settingsConfig.editOpc.link}`);

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <NavigationHeader
                        pageTitle={'Oracle Primavera Cloud'}
                        items={[
                            {
                                label: 'Integrations',
                                to: AppRoutes.buildPath(AppRoutes.SETTINGS, settingsConfig.integrations.link),
                                noEllipsis: true,
                            },
                            {
                                label: 'Oracle Primavera Cloud',
                                noEllipsis: true,
                            },
                        ]}
                    />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <OpcCredentials isEditMode={isEditMode} />
            </MainContent>
        </PageContainer>
    );
};
